import React from 'react';
import video_slide from './slide.mp4';
import './Slider.css'; // Import the CSS file

const VideoPlayer = () => {
  return (
    <div className="video-container">
      <video className="responsive-video" autoPlay muted loop>
        <source src={video_slide} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VideoPlayer;
